import { render } from "./AtomChartQuadrant.vue?vue&type=template&id=3c10d2c8&ts=true"
import script from "./AtomChartQuadrant.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomChartQuadrant.vue?vue&type=script&lang=ts&setup=true"

import "./AtomChartQuadrant.vue?vue&type=style&index=0&id=3c10d2c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/AtomChartQuadrant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c10d2c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c10d2c8', __exports__)) {
    api.reload('3c10d2c8', __exports__)
  }
  
  module.hot.accept("./AtomChartQuadrant.vue?vue&type=template&id=3c10d2c8&ts=true", () => {
    api.rerender('3c10d2c8', render)
  })

}


export default __exports__